import { Navigate } from "react-router-dom";
import { ROUTES } from "../consts/routes.consts";
import { useGetUsersListQuery } from "../apis/userDetailsAPi";
import { CircularProgress } from "@mui/material";
import MetaNewCompaing from "../../pages/metaAds/create-campaings";

const ALLOWED_EMAIL = "mapsjohn89@gmail.com";

export const ProtectedMetaNewCampaignRoute = () => {
  const { data: userData, isLoading } = useGetUsersListQuery<any>();
  const user = userData?.user;
  const userEmail = user?.email;

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-[9999] min-h-screen flex items-center justify-center backdrop-blur-[20px] bg-[rgba(0,0,0,0.5)]">
        <CircularProgress size={50} style={{ color: "#ffffff" }} />
      </div>
    );
  }

  if (!userEmail || userEmail !== ALLOWED_EMAIL) {
    return <Navigate to={ROUTES.HOME} replace={true} />;
  }

  return <MetaNewCompaing />;
};

